import { environment } from './../../environments/environment';
import { KeycloakService } from 'keycloak-angular';
import { RoleService } from '@shared/services/role/role.service';
import { UserRoles } from './auth.model';
import { defer, map, switchMap } from 'rxjs';

export function initializeKeycloak(
  keycloak: KeycloakService,
  roleService: RoleService
) {
  const deferPromisekeycloack$ = defer(() =>
    keycloak.init({
      config: {
        url: environment.authUrl, //https://localhost:8443
        realm: environment.authRealm, //frontend
        clientId: environment.authClientId, //portale-formazione-web
      },
      initOptions: {
        onLoad: 'login-required', //login-required
        // silentCheckSsoRedirectUri:
        // window.location.origin + '/assets/silent-check-sso.html',
        flow: 'implicit',
        checkLoginIframe: false,
      },
    })
  );
  const deferPromiseLoggedIn$ = defer(() =>
    keycloak.isLoggedIn().then((isLogged) => {
      if (isLogged) {
        roleService.setListaRuoliUtente(
          keycloak
            .getUserRoles()
            .filter((role) =>
              Object.values(UserRoles).includes(role as UserRoles)
            )
        );
        if (!roleService.isRuoloAttualeSettedOnStorage()) {
          roleService.setRuoloAttuale(roleService.getRuoloPrincipaleUtente());
        } else {
          if (roleService.isRuoloOnStorageValid()) {
            roleService.setRuoloAttualeFromStorage();
          } else {
            roleService.setRuoloAttuale(roleService.getRuoloPrincipaleUtente());
          }
        }
      }
    })
  );

  return () => deferPromisekeycloack$.pipe(
    switchMap((value) => {
      return deferPromiseLoggedIn$.pipe(
        map(() => {
          return value;
        })
      );
    })
  );;
}
